import { gql } from 'graphql.macro';

const adminOrderOrganizationFields = gql`
    fragment adminOrderOrganizationFields on AdminOrderOrganization {
        _id
        name
        type
    }
`;

export const adminOrdersTemplate = gql`
    query adminOrders($filters: AdminOrderFilters, $limit: Int, $offset: Int) {
        adminOrders(filters: $filters, limit: $limit, offset: $offset) {
            total
            totalIsEstimate
            searchTruncated
            items {
                _id
                orderId
                internalOrderId
                status
                rejectStatus
                isDraft
                createdOn
                deliveryDate
                customer {
                    ...adminOrderOrganizationFields
                }
                supplier {
                    ...adminOrderOrganizationFields
                }
                createdBy {
                    _id
                    fullName
                }
                patientName
                restorationTypes
                currentStep
                isPaused
            }
        }
    }
    ${adminOrderOrganizationFields}
`;

export const adminOrderTemplate = gql`
    query adminOrder($id: MongoDbObjectId!) {
        adminOrder(id: $id) {
            _id
            orderId
            internalOrderId
            vendorReference
            status
            rejectStatus
            invoicingState
            invoiceId
            invoiceNumber
            isDraft
            isSupplierOrder
            isWarrantyOrder
            isCopyOrder
            isImportedOrder
            version
            currency
            createdOn
            updatedOn
            deliveryDate
            customer {
                ...adminOrderOrganizationFields
            }
            supplier {
                ...adminOrderOrganizationFields
            }
            clinic {
                ...adminOrderOrganizationFields
            }
            lab {
                ...adminOrderOrganizationFields
            }
            createdBy {
                _id
                fullName
                email
            }
            dentist {
                _id
                fullName
                email
            }
            patient {
                firstName
                lastName
                personalIdentityNumber
            }
            currentStep
            isPaused
            additionalInfo
            restorations {
                type
                teeth
                actions
                materials
                warranty
            }
            orderRef {
                _id
                orderId
                type
            }
            linkedOrders {
                _id
                orderId
                type
            }
            events {
                type
                date
                message
                user {
                    _id
                    fullName
                }
            }
        }
    }
    ${adminOrderOrganizationFields}
`;

export const adminOrganizationSearchTemplate = gql`
    query adminOrganizationSearch($search: String!, $type: String, $limit: Int) {
        adminOrganizationSearch(search: $search, type: $type, limit: $limit) {
            _id
            name
            type
            organizationNumber
            city
        }
    }
`;

export const organizationUsersForImpersonationTemplate = gql`
    query organizationUsersForImpersonation($orgId: MongoDbObjectId) {
        users(orgId: $orgId, filters: { active: true }, limit: 100, offset: 0) {
            _id
            fullName
            email
            role
        }
    }
`;
